import { db, firebaseInitialized, appCheckEnabled } from '../firebase';
import { collection, addDoc, serverTimestamp, query, where, getDocs } from 'firebase/firestore';
import { FirebaseError } from 'firebase/app';
import appDefaultExport from '../firebase';

const API_URL = process.env.REACT_APP_API_URL;

export const addToWaitlist = async (email) => {
  try {
    await firebaseInitialized;
    
    // Ensure App Check is enabled before allowing submission
    if (!appCheckEnabled) {
      throw new Error('SECURITY_CHECK_FAILED');
    }

    // We'll skip trying to get the App Check token manually since 
    // it's automatically included in Firestore requests
    // and the previous attempt was causing errors

    // Check if email already exists
    const q = query(collection(db, 'waitlist'), where('email', '==', email));
    const querySnapshot = await getDocs(q);
    
    if (!querySnapshot.empty) {
      throw new Error('EMAIL_EXISTS');
    }
    
    return await addDoc(collection(db, 'waitlist'), {
      email,
      timestamp: serverTimestamp()
    });
  } catch (error) {
    if (error.message === 'EMAIL_EXISTS') {
      throw error;
    }
    if (error instanceof FirebaseError && error.code === 'permission-denied') {
      throw new Error('Security check failed. Please try again.');
    }
    if (error.message === 'SECURITY_CHECK_FAILED') {
      throw new Error('Security verification failed. Please refresh and try again.');
    }
    throw error;
  }
};

export const checkWaitlistStatus = async (email) => {
  try {
    if (!email) {
      return false;
    }

    // Use POST endpoint to check waitlist status
    const response = await fetch(`${API_URL}/data/check-waitlist`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: email
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    
    // Return the exists boolean from the API response
    return result.success && result.data?.exists === true;
  } catch (error) {
    console.error('Error checking waitlist status:', error);
    // Return false on error to default to standard trial
    return false;
  }
};
